import { NgModule } from '@angular/core';
import {CommonModule, DatePipe, LowerCasePipe} from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import {IonicModule} from '@ionic/angular';
// modules
import { SharedModule } from 'src/app/shared/shared.module';
// containers
import { HomeComponent } from './containers/home/home.component';
import { HomeScreenComponent } from './components/home-screen/home-screen.component';
import {HomeLocaionDetectingComponent} from './containers/home-locaion-detecting/home-locaion-detecting.component';
import {
  LocationDetectingModalComponent
} from './containers/home-locaion-detecting/location-detecting-modal/location-detecting-modal.component';
import {GoogleMapsModule} from '@angular/google-maps';
import {FormsModule} from '@angular/forms';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatButtonModule} from '@angular/material/button';
import {MatDialogModule} from '@angular/material/dialog';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatSelectModule} from '@angular/material/select';
import {MatInputModule} from '@angular/material/input';
import { ShiftSelectionModalComponent } from './containers/home-locaion-detecting/shift-selection-modal/shift-selection-modal.component';


const routes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'home-screen', component: HomeScreenComponent },

];

@NgModule({
  declarations: [
    HomeComponent,
    HomeScreenComponent,
    HomeLocaionDetectingComponent,
    LocationDetectingModalComponent,
    ShiftSelectionModalComponent
  ],
  providers: [DatePipe, LowerCasePipe],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    IonicModule,
    SharedModule,
    GoogleMapsModule,
    FormsModule,
    MatProgressSpinnerModule,
    MatButtonModule,
    MatDialogModule,
    MatExpansionModule,
    MatSelectModule,
    MatInputModule
  ]
})
export class HomeModule {}
